// // import React from 'react';
// // import ReactDOM from 'react-dom/client';
// // import './index.css';
// // import App from './App';
// // import reportWebVitals from './reportWebVitals';

// // const root = ReactDOM.createRoot(document.getElementById('root'));
// // root.render(
// //   <React.StrictMode>
// //     <App />
// //   </React.StrictMode>
// // );

// // // If you want to start measuring performance in your app, pass a function
// // // to log results (for example: reportWebVitals(console.log))
// // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();


// import React, { createContext, useContext, useEffect } from 'react';
// import ReactDOM from "react-dom";
// import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
// import './index.css';
// import App from './App';
// import { msalB2CInstance, msalADInstance } from './config.js';
// import reportWebVitals from './reportWebVitals';

// const msalInstanceAD = msalADInstance;
// const msalInstanceB2C = msalB2CInstance;
// const AuthContext = createContext();
// export const AuthProvider = ({ children }) => { 
//   const authType = localStorage.getItem("authType") ?? '';
//   console.log("authType", authType);
//   const isAuthenticated = useIsAuthenticated();
//   console.log("isAuthenticated", isAuthenticated);
//   return (
//     <AuthContext.Provider >
//       <MsalProvider instance={msalInstanceAD}> {children}</MsalProvider>
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

// ReactDOM.render(
//   <React.StrictMode>
//     <AuthProvider>
//       <App />
//     </AuthProvider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import "./index.css";
import("./bootstrap");
